module.exports = __webpack_public_path__ + "static/media/iterateIcon.5ef2a613.svg";